import { atom } from 'jotai';

export interface IAuditGroup {
  id?: string;
  name: string;
  created_at?: string;
  updated_at?: string;
}

export interface IAuditGroupInput extends Omit<IAuditGroup, 'id' | 'created_at' | 'updated_at'> {}

export const auditGroupsAtom = atom<IAuditGroup[]>([]);
export const auditGroupsLoadingAtom = atom<boolean>(false);


